module.exports = __webpack_public_path__ + "static/img/AvenirLTProMedium.8a6991c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProMedium.svg
// module id = Zvp4
// module chunks = 1